export const COLOR_STOPS = {
    total: ['#0f3d2a', '#0d5c3a', '#0a8a54', '#08c46a', '#4de08f'],
    failed: ['#3d0f10', '#5c0d0f', '#8a0a0c', '#ff4d4f', '#ff8a8b'],
} as const;

export const WEEKDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
